import React, { useState } from "react";
//import HttpCommon from "../../Utils/http-common";
import "./ForgetPassword.css";
import { forgotPassword } from "../../api/axios";
import { CircularProgress } from "@mui/material";
import { Link } from "react-router-dom";
import { showToast } from "../../Utills/toast";

const ForgetPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const res = await forgotPassword({ email: email });
      if (res.data.success !== false) {
        showToast({
          type: 'success',
          message: res.data.message || 'Email sent successfully.',
        });
      } else {
        showToast({
          type: 'error',
          message: res.data.message || 'Failed to send email. Please try again.',
        });
      }
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
      showToast({
        type: 'error',
        message: error.response.data.message || 'Failed to send email. Please try again.',
      });
    }
  };

  return (
    <div className="cont">
    <form onSubmit={handleSubmit}>
      <h1>Forgot Password</h1>
      <div className="field d-inline text-start">
        <label>Email</label>
                <div className="form-group">
                  <input
                    type="email"
                    className="form-control border light-green-box"
                    placeholder="Enter your email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
      </div>
      <div className="middle w-100">
          <div className="right w-100 d-flex justify-content-center">
            <label>
              <p className="mb-0">
                <Link to="/login" className="text-decoration-none">
                  {" "}
                  <u>Back to login</u>
                </Link>
              </p>
            </label>
          </div>
        </div>
      <button id="btn1" type="submit"  className="btn-primary w-100" >
        {loading ? <CircularProgress style={{ textAlign: "center", color: "black", height: '30px', width: "30px" }} /> : "Send Email"}
      </button>
    </form>
  </div>
  );
};

export default ForgetPassword;
